import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 32 32'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  {
    fill: 'none'
  },
  [
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M14.07 3.567a3 3 0 0 1 3.86 0l9 7.568A3 3 0 0 1 28 13.431v12.57a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2v-7h-5v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V13.43a3 3 0 0 1 1.07-2.296l9-7.568zm2.574 1.53a1 1 0 0 0-1.288 0l-9 7.57A1 1 0 0 0 6 13.43v12.57h5.5v-7a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v7H26V13.43a1 1 0 0 0-.356-.765l-9-7.568z',
      fill: 'currentColor'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'Home32Regular',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
